var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 318,
    height: 211,
    viewBox: "0 0 318 211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4",
    x: 0,
    y: 0,
    width: 256,
    height: 211,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(-1473 -84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(1624.656 155.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4-2",
    "data-name": "Rectangle 4",
    width: 166,
    height: 121,
    rx: 10,
    transform: "translate(0.344 0.3)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(21.003 59.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M.307,19.263A21.225,21.225,0,0,0,7.427,9.11c.77-2.38,1.159-4.984,2.812-6.892a.98.98,0,0,1,.606-.349c.6-.075.836.458,1,.917l2.9,8.03a4.162,4.162,0,0,0,1.106,1.9,4.148,4.148,0,0,0,1.378.643l5.878,1.9a1.994,1.994,0,0,0,2.53-1.342l3.64-12.559c.137-.474.565-1.07.977-.8C32.469,5.4,32.641,11.5,34.08,16.752A1,1,0,0,0,36,16.776c1.365-4.554.831-10.009,1.946-14.57a1.315,1.315,0,0,1,.845-.951c.923-.3,1.514.7,1.849,1.516A57.326,57.326,0,0,0,45.1,11.479c1.208,1.934,2.755,3.948,4.994,4.38.9.173,1.826.07,2.728.209,2.182.337,3.913,2.039,5.105,3.9s2.006,3.946,3.281,5.748a5.477,5.477,0,0,0,3,2.362c1.853.442,3.78-.789,4.758-2.424a13.617,13.617,0,0,0,1.444-5.484L71.581,10.2A.957.957,0,0,1,72.6,9.339c.561.056.691.581.771,1.033q2.058,11.6,3.715,23.272c.489,3.444.969,6.954,2.447,10.1a2.369,2.369,0,0,0,.859,1.117,2.711,2.711,0,0,0,2.119-.092c3.246-1.006,35.626-.441,39,0",
    transform: "translate(-0.307 -0.5)",
    fill: "none",
    stroke: "#eb6f21",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(12.841 13.323)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 133.089,
    height: 33.646,
    rx: 10,
    fill: "#ffd0b2",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 16.449,
    height: 15.701,
    rx: 5,
    transform: "translate(8.225 8.972)",
    fill: "#9b9b9b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 94.209,
    height: 5.982,
    rx: 2.991,
    transform: "translate(29.16 14.206)",
    fill: "#9b9b9b",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    width: 21.446,
    height: 2.323,
    rx: 1.162,
    transform: "translate(103.249 70.825)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_702",
    "data-name": "Rectangle 702",
    width: 15.37,
    height: 2.323,
    rx: 1.162,
    transform: "translate(103.249 74.042)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703",
    "data-name": "Rectangle 703",
    width: 15.37,
    height: 2.323,
    rx: 1.162,
    transform: "translate(103.249 77.544)",
    fill: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(1517.668 128.672)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -44.67, -44.67)",
    filter: "url(#Rectangle_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4-3",
    "data-name": "Rectangle 4",
    width: 166,
    height: 121,
    rx: 10,
    transform: "translate(45 45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_81-2",
    "data-name": "Group 81",
    transform: "translate(21.432 60.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82-2",
    "data-name": "Group 82",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1313-2",
    "data-name": "Path 1313",
    d: "M.307,19.263A21.225,21.225,0,0,0,7.427,9.11c.77-2.38,1.159-4.984,2.812-6.892a.98.98,0,0,1,.606-.349c.6-.075.836.458,1,.917l2.9,8.03a4.162,4.162,0,0,0,1.106,1.9,4.148,4.148,0,0,0,1.378.643l5.878,1.9a1.994,1.994,0,0,0,2.53-1.342l3.64-12.559c.137-.474.565-1.07.977-.8C32.469,5.4,32.641,11.5,34.08,16.752A1,1,0,0,0,36,16.776c1.365-4.554.831-10.009,1.946-14.57a1.315,1.315,0,0,1,.845-.951c.923-.3,1.514.7,1.849,1.516A57.326,57.326,0,0,0,45.1,11.479c1.208,1.934,2.755,3.948,4.994,4.38.9.173,1.826.07,2.728.209,2.182.337,3.913,2.039,5.105,3.9s2.006,3.946,3.281,5.748a5.477,5.477,0,0,0,3,2.362c1.853.442,3.78-.789,4.758-2.424a13.617,13.617,0,0,0,1.444-5.484L71.581,10.2A.957.957,0,0,1,72.6,9.339c.561.056.691.581.771,1.033q2.058,11.6,3.715,23.272c.489,3.444.969,6.954,2.447,10.1a2.369,2.369,0,0,0,.859,1.117,2.711,2.711,0,0,0,2.119-.092c3.246-1.006,35.626-.441,39,0",
    transform: "translate(-0.307 -0.5)",
    fill: "none",
    stroke: "#21d17f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_225-2",
    "data-name": "Group 225",
    transform: "translate(13.27 13.528)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78-2",
    "data-name": "Rectangle 78",
    width: 133.089,
    height: 33.646,
    rx: 10,
    fill: "#adeed0",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100-2",
    "data-name": "Rectangle 100",
    width: 16.449,
    height: 15.701,
    rx: 5,
    transform: "translate(8.225 8.972)",
    fill: "#21d17f",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101-2",
    "data-name": "Rectangle 101",
    width: 94.209,
    height: 5.982,
    rx: 2.991,
    transform: "translate(29.16 14.206)",
    fill: "#9b9b9b",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701-2",
    "data-name": "Rectangle 701",
    width: 21.446,
    height: 2.323,
    rx: 1.162,
    transform: "translate(103.677 71.03)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_702-2",
    "data-name": "Rectangle 702",
    width: 15.37,
    height: 2.323,
    rx: 1.162,
    transform: "translate(103.677 74.247)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703-2",
    "data-name": "Rectangle 703",
    width: 15.37,
    height: 2.323,
    rx: 1.162,
    transform: "translate(103.677 77.749)",
    fill: "#9b9b9b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.9b3971e0a984d447f1293f0986c53898.svg";
export { ForwardRef as ReactComponent };